// Types et constantes basés sur le schema JSON widget-schema.json
export const WidgetTypes = {
    PIE: 'pie',
    DONUT: 'donut',
    BAR: 'bar',
    LINE: 'line',
    AREA: 'area',
    SCATTER: 'scatter',
    RADAR: 'radar',
    GAUGE: 'gauge',
    TABLE: 'table',
    METRIC: 'metric',
    FUNNEL: 'funnel',
    HEATMAP: 'heatmap',
    // Fluent UI specific chart types
    GAUGE_FLUENT: 'gauge-fluent',
    BAR_FLUENT: 'bar-fluent',
    DONUT_FLUENT: 'donut-fluent',
    HORIZONTAL_BAR_FLUENT: 'horizontal-bar-fluent',
    // Specialized table types
    SLA_TABLE: 'sla-table',
    ABANDON_TABLE: 'abandon-table'
};

export const FilterTypes = {
    DATE_RANGE: 'dateRange',
    SELECT: 'select',
    MULTI_SELECT: 'multiSelect',
    TEXT: 'text',
    NUMBER: 'number',
    NUMBER_RANGE: 'numberRange',
    BOOLEAN: 'boolean'
};

export const DataSourceTypes = {
    SYNAPSE: 'synapse',
    DATALAKE: 'datalake',
    API: 'api'
};

const widgetTypesExport = { WidgetTypes, FilterTypes, DataSourceTypes };
export default widgetTypesExport;
